
import Vue from 'vue'
import { bottom } from '@/assets/menu'
import { IMenuProps } from '@/entities/Menu'

interface IData {
  bottom: IMenuProps[]
}

const component = Vue.extend({
  data(): IData {
    return {
      bottom
    }
  },
  computed: {
    __current(): string | null {
      return this.$route.name?.split('-')[0] || null
    }
  },
  methods: {
    change(value: string) {
      if (value === 'menu') {
        this.App.state.drawer = true
      } else {
        this.$router.push({ name: value })
      }
    }
  }
})

Vue.component('MAppBottom', component)
export default component
